export const REQUIRED_FIELD = 'This field is required'
export const INTEGER_FIELD = 'Must be a integer'
